export default __webpack_public_path__ + "static/media/profile-photo-icon.d183c002.svg";